// ============================================================================
// BonBoZ: màu cho biểu đồ thống kê.
//
// VÌ SAO CẦN FILE NÀY: Chart.js nhận màu là CHUỖI đã tính sẵn, không hiểu
// `var(--…)`. Upstream vì thế viết cứng `rgb(31, 147, 255)` trong
// `reports/constants.js` — hằng số ở cấp module, tính đúng MỘT lần lúc import.
// Hệ quả: đổi sang nền tối thì cột vẫn giữ nguyên màu của nền sáng.
//
// Cách vá: Chart.js cho phép truyền HÀM thay cho giá trị màu ("scriptable
// option") và gọi hàm đó ở MỖI lần vẽ. Nên đọc biến CSS ngay lúc vẽ là màu tự
// bám theo theme đang bật, không cần theo dõi sự kiện đổi theme.
//
// Biến `--bonboz-*` khai ở `assets/scss/_bonboz-theme.scss`, đã chạy qua bộ
// kiểm tương phản + mù màu cho cả hai nền.
// ============================================================================

// Đọc một biến CSS trên <html> và trả về chuỗi `rgb(...)` Chart.js dùng được.
// Biến lưu dạng bộ ba "39 129 246" (quy ước của Chatwoot) chứ không phải mã hex.
//
// `mo` = mức mờ, dùng cho phần nền nhạt dưới đường kẻ.
// Có `duPhong` vì lúc chưa gắn vào DOM (test, render phía máy chủ) thì
// `getComputedStyle` trả chuỗi rỗng — trả màu rỗng khiến Chart.js vẽ đen.
export function mauCss(ten, mo = 1, duPhong = '39 129 246') {
  // Đọc từ `document.body`, KHÔNG phải `documentElement`: dashboard gắn lớp
  // `dark` vào <body> (`helper/themeHelper.js:11`), nên bảng màu nền tối chỉ
  // hiện ra ở tầng body. Đọc ở <html> thì nền tối vẫn trả về màu nền sáng.
  const bo =
    typeof document === 'undefined' || !document.body
      ? ''
      : getComputedStyle(document.body).getPropertyValue(ten).trim();
  const so = bo || duPhong;
  return mo === 1 ? `rgb(${so})` : `rgb(${so} / ${mo})`;
}

// Màu chủ đạo của cột: xanh "đang mở" — cùng màu với thẻ số liệu cùng trang,
// nên nhìn thẻ rồi nhìn biểu đồ là biết đang nói về cùng một thứ.
export const mauCot = () => mauCss('--bonboz-mo');

// Cột lúc rê chuột: đậm hơn một nấc để biết đang trỏ vào cột nào.
export const mauCotSang = () => mauCss('--bonboz-mo', 0.82);
